export const parseInAppMessageAction = (action: string) => {
  const [actionScheme, encodedUrl] = action.split('?url=');

  return {
    isShare: actionScheme === 'action://share',
    isOpenUrl: actionScheme === 'action://open-url',
    url: encodedUrl ? decodeURIComponent(encodedUrl) : undefined,
  };
};
